<template>
  <b-modal
    content-class="mymodalContent"
    modal-class="mymodal"
    body-class="howToModalBody"
    id="howTo"
    size="custom"
    centered
    scrollable
    hide-header
    @show="onShow"
    @hide="onHide"
  >
    <div class="modal-div">
      <h2 v-html="$t('components.popinHowToUse.title')"></h2>

      <p v-html="content[index]"></p>
    </div>
    <div slot="modal-footer" class="popin-actions howto-actions">
      <b-button
        class="popin-btn-cancel"
        v-if="index > 0"
        @click="index -= 1"
      >
        <chevron-left-icon title="" />{{
          $t("components.popinHowToUse.btnPrevious")
        }}
      </b-button>
      <span v-else class="howto-spacer"></span>
      <b-button
        class="refonte_btn-primary popin-btn-confirm"
        v-if="index < content.length - 1"
        @click="index += 1"
      >
        {{ $t("components.popinHowToUse.btnNext")
        }}<chevron-right-icon title="" />
      </b-button>
      <b-button
        class="refonte_btn-primary popin-btn-confirm"
        v-else
        @click="hideModal()"
      >
        <check-icon title="" />{{ $t("components.popinHowToUse.btnClose") }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import ChevronLeftIcon from "vue-material-design-icons/ChevronLeft.vue";
import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue";
import CheckIcon from "vue-material-design-icons/Check.vue";

export default {
  name: "PopinHowToUse",
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckIcon
  },
  data: function() {
    return {
      content: this.$i18n.t("components.popinHowToUse.content"),
      index: 0
      /*contentDisplayed: this.$i18n.t("components.popinHowToUse.content1")*/
    };
  },
  methods: {
    /**
     * Callback appelée juste avant l'affichage de la modale
     * @param bvModalEvt - Objet BvModalEvent
     */
    onShow: function(bvModalEvt) { //eslint-disable-line no-unused-vars
      this.index = 0;
    },
    /**
     * Callback appelée juste avant le masquage de la modale
     * @param bvModalEvt - Objet BvModalEvent
     */
    onHide: function(bvModalEvt) { //eslint-disable-line no-unused-vars
    },
    
    hideModal: function() {
      // si la popin HowToUse a été lue, on le notifie dans le sessionStorage afin de ne plus l'afficher à l'écran par défaut.
      if (sessionStorage.getItem("howTo") === null) {
        sessionStorage.setItem("howTo", "read");
      }
      this.$bvModal.hide("howTo");
    }
  }
};
</script>

<style lang="sass">
@import "../../sass/_variables.sass"
@import "../../sass/_media.sass"

// le CSS de la modal ne doit pas être "scoped"

.modal-custom

  @media screen and (min-width: #{$screen-md-max}) 
    max-width: 1000px

  .howToModalBody
    min-height: 6em

    @media screen and (min-height: 30em) 
      height: 20em

    @media screen and (min-height: 40em) 
      height: 30em

.howto-actions
  width: 100%
  margin-top: 0

  @media (max-width: 576px)
    .howto-spacer
      display: none

</style>
